import React from 'react';
import AuthForm from '@/components/auth/AuthForm';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const Index = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-white to-[#F8F7FF] flex flex-col">
      {/* Use the shared Header component */}
      <Header />

      {/* Main content */}
      <main className="flex-1 flex flex-col items-center justify-center p-4">
        <div className="max-w-md w-full mx-auto">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold mb-2">
              <span className="text-roundone-dark-purple">Welcome to </span>
              <span className="gradient-text">RoundOne</span>
            </h1>
            <p className="text-muted-foreground mb-8">
              Login or create an account to get started
            </p>
          </div>
          
          <AuthForm />
        </div>
      </main>

      {/* Use the shared Footer component */}
      <Footer />
    </div>
  );
};

export default Index;
